import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/ConsumptionMeteringPointGroupModal.module.scss';

import Button from '../../Common/Button';
import Loading from '../../Common/Loading';

import { closeMenuIconBlack } from '../../../icons';

import { deleteMeteringPointGroup } from '../../../actions/meteringPointGroups';
import { MeteringPointGroup } from '../../../types/consumptionRates';

export type ConsumptionMeteringPointGroupDeleteProps = {
  group: MeteringPointGroup;
  setShowDeleteModal: (value: React.SetStateAction<boolean>) => void;
  setRefreshData?: (value: React.SetStateAction<string>) => void;
};

const ConsumptionMeteringPointGroupDelete: React.FunctionComponent<ConsumptionMeteringPointGroupDeleteProps> = (
  props: ConsumptionMeteringPointGroupDeleteProps,
) => {
  const { t } = useTranslation();
  const { group, setShowDeleteModal, setRefreshData } = props;

  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const submitForm = async (): Promise<void> => {
    setSubmitting(true);
    const groupSubmitStatus = await deleteMeteringPointGroup(parseInt(group.userIdentifier), group.identifier);
    setSubmitting(false);
    if (groupSubmitStatus === 200) {
      setShowDeleteModal(false);
      setRefreshData && setRefreshData('groups');
    }
  };

  return (
    <>
      <div className={`modal ${styles.modalWrapper}`}>
        <div className={styles.modal}>
          <button className={styles.close} onClick={(): void => setShowDeleteModal(false)}>
            <img src={closeMenuIconBlack} alt={t('common:general.close')} />
          </button>
          <h1 className={styles.title}>
            {t(`consumption:meteringPointGroup.deleteGroupTitle`)}
            <br />
            {group.groupName}
          </h1>
          <p className={styles.ingress}>{t(`consumption:meteringPointGroup.deleteGroupIngress`)}</p>

          <div className={styles.deleteButtons}>
            <Button className="buttonWhite" onClick={() => setShowDeleteModal(false)}>
              {t(`common:general.cancel`)}
            </Button>
            {submitting && <Loading size="small" />}
            {!submitting && <Button onClick={() => submitForm()}>{t(`common:general.deleteButton`)}</Button>}
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsumptionMeteringPointGroupDelete;
